/* SAEVENTEEN Arcade V4 Liquid Glass switch — scoped, accessible, no dependencies */
(function(){
  'use strict';
  const storageKey='saeventeen_arcade_liquid_glass_v4';
  function init(root){
    if(root.dataset.saeGlassReady==='1') return;
    root.dataset.saeGlassReady='1';
    const button=root.querySelector('[data-sae-glass-toggle]');
    const state=root.querySelector('[data-sae-glass-toggle-state]');
    const defaultEnabled=root.dataset.saeGlassDefault==='true';
    const visitorSwitch=root.dataset.saeGlassSwitch==='true';
    let enabled=defaultEnabled;
    if(visitorSwitch){
      try {const saved=localStorage.getItem(storageKey);if(saved==='on'||saved==='off')enabled=(saved==='on');}catch(_error){}
    }
    function render(){
      root.classList.toggle('sae-arcade--glass',enabled);
      if(button){button.setAttribute('aria-pressed',String(enabled));}
      if(state){state.textContent=enabled?'ON':'OFF';}
    }
    render();
    if(button){button.addEventListener('click',function(){
      enabled=!enabled;
      try{localStorage.setItem(storageKey,enabled?'on':'off');}catch(_error){}
      render();
    });}
  }
  function boot(){document.querySelectorAll('[data-sae-arcade]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  document.addEventListener('shopify:section:load',boot);
})();
